import { AppEnv } from '../appEnv';
import { assertNever } from '../assertNever';

export type RecruitNurseSenkaUrl =
  | 'https://dev-recruit.nurse-senka.com'
  | 'https://stg-recruit.nurse-senka.com'
  | 'https://recruit.nurse-senka.com';

// ナース専科就職ナビ（通称NG）のURLを返す
export const recruitNurseSenkaUrl = (appEnv: AppEnv): RecruitNurseSenkaUrl => {
  switch (appEnv) {
    case 'local':
    case 'qa':
      return 'https://dev-recruit.nurse-senka.com';
    case 'staging':
      return 'https://stg-recruit.nurse-senka.com';
    case 'production':
      return 'https://recruit.nurse-senka.com';
    default:
      return assertNever(appEnv);
  }
};

export type JobNurseSenkaUrl =
  | 'https://stg-job.nurse-senka.jp'
  | 'https://job.nurse-senka.jp';

// ナース専科求人ナビのURLを返す
export const jobNurseSenkaUrl = (appEnv: AppEnv): JobNurseSenkaUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
    case 'qa':
      return 'https://stg-job.nurse-senka.jp';
    case 'production':
      return 'https://job.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export type NjbUrl =
  | 'https://stg.nursejinzaibank.com'
  | 'https://www.nursejinzaibank.com';

// ナース人材バンク（通称NJB）のURLを返す
export const njbUrl = (appEnv: AppEnv): NjbUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
    case 'qa':
      return 'https://stg.nursejinzaibank.com';
    case 'production':
      return 'https://www.nursejinzaibank.com';
    default:
      return assertNever(appEnv);
  }
};
